import React from "react";

import {
  DialogTrigger as AriaDialogTrigger,
  Heading as AriaHeading,
  Popover as AriaPopover,
  PopoverProps as AriaPopoverProps,
  composeRenderProps,
  DialogTriggerProps,
  HeadingProps,
  OverlayArrow,
} from "react-aria-components";
import { tv } from "tailwind-variants";

export interface IPopoverProps extends Omit<AriaPopoverProps, "children"> {
  showArrow?: boolean;
  children: React.ReactNode;
}

export function DialogTrigger({ children, ...props }: DialogTriggerProps) {
  return <AriaDialogTrigger {...props}>{children}</AriaDialogTrigger>;
}

export function Heading({ children, ...props }: HeadingProps) {
  return <AriaHeading {...props}>{children}</AriaHeading>;
}

const styles = tv({
  base: "bg-backgroundTertiary forced-colors:bg-[Canvas] border border-borderTertiary text-contentPrimary shadow-lg rounded-lg p-1.5",
  variants: {
    isEntering: {
      true: "animate-in fade-in zoom-in-95 placement-bottom:slide-in-from-top-1 placement-top:slide-in-from-bottom-1 placement-left:slide-in-from-right-1 placement-right:slide-in-from-left-1 ease-out duration-base",
    },
    isExiting: {
      true: "animate-out fade-out ease-in duration-fast",
    },
  },
});

export function Popover({
  children,
  showArrow,
  className,
  ...props
}: IPopoverProps) {
  return (
    <AriaPopover
      offset={showArrow ? 12 : 8}
      {...props}
      className={composeRenderProps(className, (className, renderProps) =>
        styles({ ...renderProps, className }),
      )}>
      {showArrow && (
        <OverlayArrow className="group">
          <svg
            width={12}
            height={12}
            viewBox="0 0 12 12"
            className="block fill-backgroundTertiary forced-colors:fill-[Canvas] stroke-1 stroke-borderTertiary forced-colors:stroke-[ButtonBorder] group-placement-bottom:rotate-180 group-placement-left:-rotate-90 group-placement-right:rotate-90">
            <path d="M0 0 L6 6 L12 0" />
          </svg>
        </OverlayArrow>
      )}
      {children}
    </AriaPopover>
  );
}
